import React from 'react';
import { content } from '../data/content';

const PrivacyPolicy = () => {
  const { privacyPolicy } = content;

  return (
    <div className="pt-32 pb-24 bg-white min-h-screen">
      <div className="container-custom max-w-4xl mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-display font-bold text-navy mb-4 text-center">
          {privacyPolicy.title}
        </h1>
        <p className="text-center text-navy/60 mb-12">
          Last Updated: {privacyPolicy.lastUpdated}
        </p>
        
        <div className="prose prose-lg max-w-none text-navy/80 space-y-8">
          <p className="whitespace-pre-line leading-relaxed">{privacyPolicy.intro}</p>
          
          {privacyPolicy.sections.map((section, idx) => (
            <div key={idx} className="mt-8">
              <h2 className="text-2xl font-bold text-navy mb-4">{section.title}</h2>
              <div 
                className="whitespace-pre-line leading-relaxed"
                dangerouslySetInnerHTML={{ __html: section.content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
